import {ColumnsEdit} from "../../../../../../types/models/column-table-edit";
import React from "react";

const configureWorkShiftsColumns: ColumnsEdit = [
    {
        title: "STT",
        key: "index",
        show: true,
        dataIndex: "index",
        render(_, __, index) {
            return <>{index + 1}</>;
        },
        width: 80,
        align: "center",
        isResizable: true,
    },
    {
        title: "Tên ca",
        dataIndex: "tenCa",
        key: "tenCa",
        show: true,
        isResizable: true,
        align: "left",
    },
    {
        title: "Thời gian bắt đầu",
        dataIndex: "thoiGianBatDau",
        key: "thoiGianBatDau",
        show: true,
        isResizable: true,
        align: "center",
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Thời gian kết thúc",
        dataIndex: "thoiGianKetThuc",
        key: "thoiGianKetThuc",
        show: true,
        align: "center",
        isResizable: true,
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Thời gian tính đi muộn",
        dataIndex: "thoiGianTinhGioDiMuon",
        key: "thoiGianTinhGioDiMuon",
        show: true,
        align: "center",
        isResizable: true,
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Thời gian vào làm từ",
        dataIndex: "thoiGianVaoLamTu",
        key: "thoiGianVaoLamTu",
        show: true,
        isResizable: true,
        align: "center",
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Thời gian vào làm đến",
        dataIndex: "thoiGianVaoLamDen",
        key: "thoiGianVaoLamDen",
        show: true,
        align: "center",
        isResizable: true,
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Số giờ làm",
        dataIndex: "soGioLam",
        key: "soGioLam",
        show: true,
        align: "center",
        isResizable: true,
        render: (text) => (text ? text : "_"),
    },
    {
        title: "Ký hiệu ca",
        dataIndex: "kyHieuCa",
        key: "kyHieuCa",
        show: true,
        isResizable: true,
        align: "left",
    },
    {
        title: "Tác vụ",
        dataIndex: "action",
        key: "action",
        show: true,
        align: "center",
    },
];

export {configureWorkShiftsColumns};